import { httpDelete, httpGet, httpPost, httpPut } from '../../../tools/http/httpClient';

export function fetchAssignxNetwork(clientType, { timeoutMs } = {}) {
  const params = new URLSearchParams({
    client_type: clientType,
    // The map already loads its edge geometry and metadata from the base
    // GeoJSON. Avoid transferring the redundant ~37 MB full graph catalog.
    include_catalog: 'false',
  });
  return httpGet(`/api/assignx/v2/network?${params.toString()}`, {
    loadingKey: 'assignx-network',
    timeoutMs,
  });
}

export function runAssignxV2(clientType, scenario, extras = {}) {
  return httpPost('/api/assignx/v2/run', {
    client_type: clientType,
    method: extras.method || 'kpath',
    scenario,
    include_base: extras.include_base ?? false,
    include_kpis: true,
    include_edge_deltas: extras.include_edge_deltas ?? true,
  }, {
    loadingKey: 'assignx-run',
    loadingText: 'Esecuzione scenario AssignX in corso…',
    showPercentage: true,
    estimatedDurationMs: 6_000,
    timeoutMs: 120_000,
  });
}

export function compareAssignxV2(clientType, left, right, extras = {}) {
  return httpPost('/api/assignx/v2/compare', {
    client_type: clientType,
    method: extras.method || 'kpath',
    left,
    right,
    bpr: extras.bpr,
  }, {
    loadingKey: 'assignx-compare',
    loadingText: 'Confronto scenari AssignX in corso…',
    showPercentage: true,
    estimatedDurationMs: 6_000,
    timeoutMs: 120_000,
  });
}

export function listScenarios(clientType, { timeoutMs } = {}) {
  return httpGet(`/api/assignx/v2/scenarios?client_type=${encodeURIComponent(clientType)}`, {
    loadingKey: 'assignx-scenarios',
    timeoutMs,
  });
}

export function saveScenario(clientType, name, definition, lastResultSummary) {
  return httpPost('/api/assignx/v2/scenarios', {
    client_type: clientType,
    name,
    definition,
    last_method: 'kpath_bpr_msa',
    last_result_summary: lastResultSummary,
  }, { loadingKey: 'assignx-save-scenario' });
}

export function updateScenario(id, name, definition, lastResultSummary) {
  return httpPut(`/api/assignx/v2/scenarios/${id}`, {
    name,
    definition,
    last_method: 'kpath_bpr_msa',
    last_result_summary: lastResultSummary,
  }, { loadingKey: 'assignx-save-scenario' });
}

export function deleteScenario(id) {
  return httpDelete(`/api/assignx/v2/scenarios/${id}`, { loadingKey: 'assignx-delete-scenario' });
}

export function createNewRoad(clientType, road) {
  return httpPost('/api/assignx/v2/new-roads', {
    client_type: clientType,
    temp_id: road.temp_id || road.uid,
    graph_u: road.graph_u || road.origin,
    graph_v: road.graph_v || road.destination,
    geometry: road.geometry,
    name: road.name,
    highway: road.highway,
    lanes: Number(road.lanes) || 1,
    speed_kph: Number(road.speed ?? road.speed_kph) || 30,
    capacity_vph: Number(road.capacity ?? road.capacity_vph) || 600,
    capacity_factor: Number(road.factor ?? road.capacity_factor) || 1,
    two_way: !!(road.twoWay ?? road.two_way),
  }, { loadingKey: 'assignx-create-road' });
}

export function deleteNewRoad(clientType, tempId) {
  const params = new URLSearchParams({ client_type: clientType, temp_id: tempId });
  return httpDelete(`/api/assignx/v2/new-roads?${params.toString()}`, { loadingKey: 'assignx-delete-road' });
}
